import { render, staticRenderFns } from "./CustomersOverview.vue?vue&type=template&id=33235942"
import script from "./CustomersOverview.vue?vue&type=script&lang=js"
export * from "./CustomersOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports